import { Callout } from '@/console/ui/Callout'
import styles from './ConsoleForbidden.module.css'

/**
 * LOGISPRD-12506 (검수 반영) — 콘솔 접근 게이트의 안내 화면.
 *
 * `ConsoleShell` 이 `AuthStorage.user.get().auth` 를 `hasConsoleAccess`(`@/utils/consoleEntry`)로
 * 판별해 'MOMS_ENG' 가 아니면 탭·사이드 내비 대신 이 화면을 렌더한다. 헤더(`ConsoleHeader`)는
 * 그대로 남아 있다 — 여기서 막는 건 콘솔 "본문" 뿐이고, 사용자가 지금 어느 화면에 있는지는 계속
 * 알 수 있어야 한다.
 *
 * 문구는 `api/errors.ts` 의 `FORBIDDEN_MESSAGE`(서버 401 을 화면에 표시할 때 쓰는 문구)와 톤·표현을
 * 맞췄다 — "~권한이 없어요. (... 권한 필요)" 구조를 그대로 따른다. 다만 문자열 자체를 그대로 재사용
 * 하지는 않았다: `FORBIDDEN_MESSAGE` 는 "MOMS_ENG 또는 MASTER" 를 언급하는데(핸드오프 §2.3 — 합포
 * 재개·정산 재발행 등 일부 액션은 지금도 MASTER 로 통과한다), 콘솔 "진입" 게이트는 사용자 확정
 * 결정으로 MOMS_ENG 단독만 허용한다. 그 문구를 그대로 쓰면 MASTER 계정이 "MASTER 도 된다"는 문구를
 * 보면서 동시에 화면은 막혀 있는 모순이 생긴다 — 그래서 문자열은 분리하되 표현 패턴만 맞춘다.
 *
 * ⚠️ 이 게이트는 UX 다. 보안 경계가 아니다 — 실제 차단은 BE `@devOpsGate`(핸드오프 §2.3)이고, 그
 * 플래그(`devops.consoleAuthz.enable`)는 지금 dev·운영 모두 OFF 라서 이 화면을 우회해 API 를 직접
 * 호출하면 인증만 되면 누구나 통과한다. "프론트에서 막으니 안전하다"고 오해하지 말 것.
 */
export const CONSOLE_ACCESS_MESSAGE = '이 화면은 권한이 없어요. (MOMS_ENG 권한 필요)'

export const ConsoleForbidden = (): JSX.Element => (
  <div className={styles.wrap}>
    <Callout tone="crit">{CONSOLE_ACCESS_MESSAGE}</Callout>
  </div>
)
